module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_3016.6f216f05.png";